import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';

import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import PageLoading from '../components/PageLoading';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import {showTemporaryUIMessage} from '../utils/UIMessageBoxes';

const formStyle = {
  margin: 16
};

const commentStyle = {
    fontFamily:'Roboto, sans-serif',
    fontSize:'16px',
    color:'rgba(0,0,0,0.870)'
}


export default
@observer class ConfirmPhoneNumberPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  // Helper method that writes values back to datamodel as fields are changed
  handleValue(event) {
    console.log("handleValue called");
    var field = event.target.dataset.propname;
    var value = event.target.value;
    AppModel.updateUserForm.user[field]=value;
  }

  sendPhoneVerification() {
    AppModelUtils.sendPhoneNumberVerification()
    .then( ()=> {
      showTemporaryUIMessage(uiMsg('CP_SMS_CODE_SENT',"SMS with verification code sent to phone."));
    })
    .catch( error => {
      console.log(error);
    });
  }
  checkVerificationCode() {
    AppModelUtils.checkPhoneNumberVerificationCode()
    .then( ()=> {
      // Two options, either code is accepted
      showTemporaryUIMessage(uiMsg('CP_PHONE_CONFIRMED',"Phone number successfully confirmed."));
      this.context.router.goBack();
    })
    .catch( error => {
      AppModel.uiError=uiMsg('CP_PHONE_CODE_REJECTED',"Verification code not accepted.  Verify that you have typed the code correctly, or request a new code to be sent.");
      console.log(error);
    });
  }


  render() {
    // We use the updateUserForm for the phone number field
    var form = AppModel.updateUserForm;
    var user = form.user;
    var busy = AppModel.verifyingPhoneOperation || AppModel.sendingPhoneVerificationCode;

    return (
      <PageLoading loading={busy}>
        <div style={formStyle}>
          <div style={commentStyle}>
            {uiMsg('CP_VERIFICATION_SENT_LABEL',"A verification code has been sent to the phone number below.")}
          </div>
          <TextField data-propname="verifycode"
                  floatingLabelText={uiMsg('CP_ENTER_VERIFICATION',"Enter verification code received in SMS")}
                  hintText={uiMsg('CP_ENTER_VERIFICATION_HINT',"Verification code")}
                  fullWidth={true}
                  value={user.verifycode || ""}
                  onChange={this.handleValue}
            />

          <RaisedButton fullWidth={false}
            primary={true}
            onTouchTap={this.checkVerificationCode.bind(this)}
            label={uiMsg('CP_B_VERIFY_CODE',"Verify code" )}
            />

            <div style={commentStyle}>
              {uiMsg('CP_NOT_RECEIVED',"If you have not received a code, double check the phone number and click button below." )}
            </div>

            <TextField data-propname="phone"
              floatingLabelText={uiMsg('CP_PHONE_NUMBER',"Mobile phone (international format including country code)")}
              hintText={uiMsg('CP_PHONE_NUMBER_HINT',"Mobile phone")}
              fullWidth={true}
              value={user.phone || ""}
              onChange={this.handleValue}
              />

            <RaisedButton fullWidth={false}
              primary={true}
              onTouchTap={this.sendPhoneVerification.bind(this)}
              label={uiMsg('CP_B_SEND_VERIFY_CODE',"Send new SMS verification code")}
              />

        </div>
      </PageLoading>
    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/ConfirmPhoneNumberPage.jsx
 **/